// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tab, { TabPresentationProps } from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import React, { FC, useState } from "react";
import { css } from "styled-components";

const enum fields {
    sections = "sections",
}
const enum sectionFields {
    id = "id",
    title = "title",
}

export interface TabsStyles {
    wrapper?: InjectableCss;
    tabGroup?: TabGroupPresentationProps;
    tabSection?: TabPresentationProps;
}

const tabsStyles: TabsStyles = {
    wrapper: {
        css: css`
            ${boxStyles()}
        `,
    },
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.sections]: [
            {
                fields: {
                    [sectionFields.id]: string;
                    [sectionFields.title]: string;
                };
            },
        ];
    };
}

const styles = tabsStyles;

const Tabs: FC<OwnProps> = ({ fields: { sections }, id }) => {
    if (!sections.length) {
        return null;
    }

    const [currentSection, setCurrentSection] = useState<string>();

    const tabsSections = sections.map(({ fields: section }, index) => {
        const { id: sectionId, title } = section;

        if (typeof currentSection === "undefined" && index === 0) {
            setCurrentSection(title);
        }

        return (
            <Tab
                key={sectionId}
                headline={title}
                tabKey={title}
                {...styles.tabSection}
                selected={currentSection === title}
            >
                <Zone contentId={id} zoneName={`TabSection-${sectionId || index}`} />
            </Tab>
        );
    });

    const onTabChange = (event: React.MouseEvent | React.KeyboardEvent, tabKey?: string) => {
        setCurrentSection(tabKey);
    };

    return (
        <TabGroup current={currentSection} {...styles.tabGroup} onTabChange={onTabChange}>
            {tabsSections}
        </TabGroup>
    );
};

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: Tabs,
    definition: {
        group: "Basic",
        displayName: "Tabs",
        fieldDefinitions: [
            {
                name: fields.sections,
                editorTemplate: "ListField",
                getDisplay: x => x.fields.title,
                defaultValue: [],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: sectionFields.id,
                        editorTemplate: "UniqueIdField",
                    },
                    {
                        name: sectionFields.title,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
